<template>
    <div class="base-psy-success">
        <header class="header">
            <div class="goback" @click="onClose">
                <img class="back" src="~images/back.png" />
                <div class="title">支付成功</div>
            </div>
            <div class="service-img" @click="toSer">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </header>
        <div class="head-title">
            <img src="~images/success.png" />
            <div>恭喜您，支付成功 !</div>
        </div>
        <div class="content">
            <div class="item">订单：{{orderId}}</div>
            <div class="item">金额：{{money}}{{unit}}</div>
            <div class="item">类型：{{payType}}支付</div>
            <div class="item">状态：<span class="sol">支付成功</span></div>
            <div class="item">时间：{{time}}</div>
            <div class="item">备注：因网络原因部分订单可能延时发货，请稍等片刻或联系客服。</div>
            <div class="btn" @click="onClose">返回</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        // 进入路由之前
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例
                
                if(!sessionStorage.getItem('h5LoginData')){
                if (vm.config.system == 1) {
                    // 竖屏
                    window.Android.setOriPortrait()
                } else {
                    // 竖屏
                    window.webkit.messageHandlers.wz_callOC.postMessage({method : 'forcePortrait'})
                }
            }
            })
        },
        name: 'BasePaySuccess',
        data () {
            return {
                orderId: null,
                unit: null,
                money: null,
                time: null,
                payType: null
            }
        },
        methods: {
            // 关闭支付页面
            onClose () {
                let that = this
                if(sessionStorage.getItem('h5LoginData')){
                        window.parent.postMessage({type:"el",info:{show:true}}, '*')
                    }

                // if (that.config.system == 1) {
                //     if(sessionStorage.getItem('h5LoginData')){
                //         window.parent.postMessage({type:"el",info:{show:true}}, '*')
                //     }else{
                //         window.Android.closePay(false, that.orderID)
                //         sessionStorage.clear()
                //           // 恢复正常屏幕
                //         window.Android.setOriBehind()
                //     }
                    
                // } else if (that.config.system == 2) {
                //     if(sessionStorage.getItem('h5LoginData')){
                //         window.parent.postMessage({type:"el",info:{show:true}}, '*')
                //     }else{
                //     window.webkit.messageHandlers.wz_callOC.postMessage({
                //         method: 'closePay',
                //         param: {
                //             payState: false,
                //             payId: that.orderID
                //         }
                //     })
                // }
                //     // 恢复正常屏幕
                //     window.webkit.messageHandlers.wz_callOC.postMessage({method : 'forceLandscapeRight'})
                // }
            },
            toSer () {
                this.$router.push('/base-service')
                if (this.config.system == 1) {
                    // 恢复正常屏幕
                    window.Android.setOriBehind()
                    }else {
                    // 恢复正常屏幕
                    window.webkit.messageHandlers.wz_callOC.postMessage({method : 'forceLandscapeRight'})
                }
        }
        },
        created () {
            this.orderId = this.$route.query.order
            this.unit = this.$route.query.type == 2 ? '平台币' : '元'
            this.payType = this.$route.query.type == 2 ? '平台币' : this.$route.query.type == 1 ? '微信' : '支付宝'
            this.money = this.$route.query.money
            this.time = moment.unix(this.$route.query.time).format('YYYY-MM-DD HH:mm')
        },
        mounted(){
            window.parent.postMessage({type:'payOk',info:1}, '*')
        }
    }
</script>

<style lang="scss" scoped>
    .base-psy-success {
        width: 100%;
        height: 100%;
        background: #fff;
        overflow-y: scroll;
        .header {
            width: 100%;
            height: 340px;
            background: #FF6B21;
            position: relative;
            display: flex;
            align-items: center;
            .goback {
                height: 340px;
                display: flex;
                align-items: center;
            }
            .back {
                width: 130px;
                height: 130px;
                margin-left: 80px;
            }
            .title {
                font-size: 92px;
                margin-left: 35px;
            }
            .service-img {
                width: 290px;
                height: 340px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: 0;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .head-title {
            height: 789px;
            font-size: 85px;
            background: #FF6B21;
            padding-top: 75px;
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
                width: 372px;
                height: 372px;
                margin-bottom: 75px;
            }
        }
        .content {
            color: #333;
            font-size: 70px;
            padding: 150px;
            overflow: hidden;
            .item {
                margin-bottom: 80px;
                .sol {
                    color: #47A252;
                }
            }
            .btn {
                width: 1375px;
                height: 200px;
                font-size: 70px;
                color: #fff;
                border-radius: 100px;
                background: #FF6B21;
                margin: 180px auto 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
</style>